/*=========================================================================================
  File Name: moduleLegalEntity.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from './moduleLegalEntityState'
import mutations from './moduleLegalEntityMutations'
import actions from './moduleLegalEntityActions'
import getters from './moduleLegalEntityGetters'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
